import { _ } from "js/vendor";

import { BlockStructureType } from "common/constants";

import { CollectionElement, CollectionItemElement } from "../base/CollectionElement";
import { TextElement } from "../base/Text/TextElement";

class TextBoxGrid extends CollectionElement {
    getChildItemType() {
        return TextBoxGridItem;
    }

    get maxItemCount() {
        return 6;
    }

    get defaultItemData() {
        return {
            title: { text: "" },
            body: { text: "" }
        };
    }

    _calcProps(props, options) {
        const { size } = props;

        const layouter = this.getLayouter(props, this.itemElements, size);
        layouter.calcTextBoxGridLayout({
            flipOrientation: this.model.flipOrientation,
            fitToText: this.model.fitToText
        });

        return { size };
    }

    _migrate_10() {
        this.model.fitToText = true;
    }
}

class TextBoxGridItem extends CollectionItemElement {
    get selectionPadding() {
        return 0;
    }

    _build() {
        this.text = this.addElement("text", () => TextElement, {
            blockStructure: BlockStructureType.TITLE_AND_BODY,
            scaleTextToFit: true,
            syncFontSizeWithSiblings: true,
        });
    }

    _calcProps(props, options) {
        const { size } = props;

        const textProps = this.text.calcProps(size, options);

        return { size: textProps.size, textScale: textProps.textScale };
    }
}

export const elements = {
    TextBoxGrid,
};
